
import { Grid } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import TextField from '../../../../components/TextField';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';
import { RegistrationStatusData, RegistrationStatusEnum } from '../../../../data/Enums';
import { useUserContext } from '../../../../contexts/UserContext';


interface IGovernanceItemFilterProps extends IDefaultDrawerProps {
    handleApplyFilters: (formData: FormData) => void;
}


const Filters: React.FC<IGovernanceItemFilterProps> = ({
    open,
    handleClose,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useUserContext();

    const [name, setName] = useState<string>('');
    const [roomTypes, setRoomTypes] = useState<number[]>([]);
    const [registrationStatus, setRegistrationStatus] = useState<number[]>([RegistrationStatusEnum.Actived, RegistrationStatusEnum.Inactived]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField 
                        label={translate('name')} 
                        name='name' 
                        value={name} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                        required={false}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SelectField
                        label={translate('roomTypes')}
                        name='roomTypes'
                        value={roomTypes.length > 0 ? roomTypes : [0]}
                        multiple={true}
                        onChange={e => {
                            const values = e.target.value as number[];
                            setRoomTypes(roomTypes.length > 0 && values.includes(0) ? [] : values.filter(v => v !== 0));
                        }}
                        data={[{ value: 0, text: translate('all') }].concat((enterprise?.partnerPms.roomTypes ?? []).map(r => {
                            return {
                                value: +r.id,
                                text: r.description
                            };
                        }))}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <SelectField
                        label={translate('situation')}
                        name='registrationStatus'
                        value={registrationStatus}
                        multiple={true}
                        required={true}
                        onChange={e => setRegistrationStatus(e.target.value)}
                        data={Object.values(RegistrationStatusData).filter(s => s.visible).map(s => {
                            return {
                                value: s.id,
                                text: translate(s.name)
                            };
                        })}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;